module.exports = __webpack_public_path__ + "media/application/images/svgs/edit-3-5f9b209fe223be42bcb142e632b0dfb5.svg";